import React, { useEffect, useState } from "react";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import { useNavigate } from "react-router-dom";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { fDate } from "../../../utils/formatTime";
import { Person as PersonIcon } from "@mui/icons-material";
import MainCard from "../../../components/Maincard";
import { useGetTokenOrLogout } from "../../../utils/token";
import HeadingCard from "../../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import CustomTextFieldComp from "../../../newTestPrep/newComponent/customTextFieldComp";
import SearchTextFieldComp from "../../../newTestPrep/newComponent/newtextfieldComp/SearchTextFieldComp";

export default function ViewTodaysEnquiry() {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const userId = localStorage.getItem("userId");
  const [enquirydata, setEnquiryData] = useState([]);
  const [originalData, setOriGinalData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const navigate = useNavigate();
  const getTokenOrLogout = useGetTokenOrLogout();
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    setLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}admindashboard/todayenquiries/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();

          if (data.length === 0) {
            showSnackbar("No enquiries found for today.", "error");
            setLoading(false);
          } else {
            const sortedData = data.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
            setEnquiryData(sortedData);
            setOriGinalData(sortedData);
            setLoading(false);
          }
        } else if (response.status === 404) {
          navigate("/page404");
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/page403");
        } else if (response.status === 440) {
          navigate("/page440");
        } else {
          navigate("/page500");
        }
      } catch {
        navigate("/page500");
      }
    };

    fetchData();
  }, [userId]);

  const handleViewMore = (row) => {
    // Handle the "View More" action here

    const url = `/enquirydetails/${row.id}`;
    const newState = { enquiryDetails: row };

    // Open link in new tab
    const newTab = window.open(url, "_blank");

    // If new tab opened successfully, navigate with state data
    if (newTab) {
      newTab.onload = () => {
        newTab.history.replaceState(newState, "", url);
      };
    } else {
      // If new tab was blocked by browser, navigate with state data in current tab
      navigate(url, { state: newState });
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Enquiry Name",
      width: 150,

      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.first_name || ""} ${params.row?.last_name || ""}`, // Use direct API fields
      renderCell: (params) => {
        return (
          <div>
            <Button size="small" onClick={() => handleViewMore(params.row)}>
              {params.row.first_name} {params.row.last_name}
            </Button>
          </div>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      headerClassName: "header-cell",

      renderCell: (params) => (
        <div>
          {params.row?.mobile_country_code}
          {params.row?.mobile}
        </div>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      headerClassName: "header-cell",

      renderCell: (params) => <div>{params.value}</div>,
    },

    {
      field: "service_id",
      headerName: "Service",
      width: 150,

      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.service_id?.service_name || "",
      renderCell: (params) => <div>{params.row?.service_id?.service_name}</div>,
    },

    {
      field: "sub_service_id",
      headerName: "Sub Service",
      width: 150,

      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.sub_service_id?.name || "",
      renderCell: (params) => params.row?.sub_service_id?.name || "",
    },

    {
      field: "campaign_id",
      headerName: "Campaign",
      width: 350,

      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.campaign_id?.campaign_name || "",
      renderCell: (params) => params.row?.campaign_id?.campaign_name || "",
    },

    {
      field: "lead_source_type_id",
      headerName: "Lead Source",
      width: 100,

      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.lead_source_type_id?.name || "",
      renderCell: (params) => params.row?.lead_source_type_id?.name || "",
    },

    {
      field: "sub_lead_source_type_id",
      headerName: "Sub Lead Source",
      width: 150,

      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.sub_lead_source_type_id?.source_type || "",
      renderCell: (params) =>
        params.row?.sub_lead_source_type_id?.source_type || "",
    },

    {
      field: "assign_to",
      headerName: "Assign To",
      width: 150,

      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params.row?.assign_to?.first_name || ""} ${
          params.row?.assign_to?.last_name || ""
        }`,
      renderCell: (params) => (
        <div>
          {" "}
          {params.row?.assign_to?.first_name} {params.row?.assign_to?.last_name}
        </div>
      ),
    },

    {
      field: "enquiry_date",
      headerName: "Enquiry Date",
      width: 150,

      headerClassName: "header-cell",
      valueGetter: (params) => fDate(params.value),
      renderCell: (params) => <div>{fDate(params.value)}</div>,
    },
    {
      field: "stage_id",
      headerName: "Stage",
      width: 100,

      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.stage_id?.stage_name || "",
      renderCell: (params) => params.value?.stage_id?.stage_name,
    },
    {
      field: "uploaded_by",
      headerName: "Uploaded By",
      width: 150,

      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.created_by?.first_name}
      ${params.row?.created_by?.last_name}`,
      renderCell: (params) => (
        <div>
          {params.row?.created_by?.first_name}{" "}
          {params.row?.created_by?.last_name}
        </div>
      ),
    },
  ];

  // Search All Column
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = originalData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.first_name || ""} ${data?.last_name || ""}`,
        `${data?.mobile_country_code || ""}${data?.mobile || ""}`,

        `${data?.email || ""}`,

        `${data?.service_id?.service_name || ""}`,

        `${data?.sub_service_id?.name || ""}`,

        `${data?.campaign_id?.campaign_name || ""}`,
        `${data?.lead_source_type_id?.name || ""}`,
        `${data?.sub_lead_source_type_id?.source_type || ""}`,
        `${data?.assign_to?.first_name || ""} ${
          data?.assign_to?.last_name || ""
        }`,
        `${data?.enquiry_date}`,
        `${data?.stage_id?.stage_name || ""}`,
        `${data?.created_by?.first_name || ""} ${
          data?.created_by?.last_name || ""
        }`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setEnquiryData(filteredData1); // Update the filtered data
  };
  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Fetching
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={4} lg={2}>
          <HeadingCard label="Imported Leads" />
        </Grid>
        <Grid item xs={12} lg={12} sm={12} md={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={12} sm={12} md={12} textAlign="end">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "end",
                  }}
                >
                  <SearchTextFieldComp onChange={handleSearch} />
                </Box>
              </Grid>

              <Grid item xs={12}>
                {" "}
                <DataGrid
                  rows={enquirydata}
                  columns={columns}
                  autoHeight
                  //getRowId={(row) => row.lead_no}
                  //autoPageSize
                  //rowHeight={70}
                  // getRowId={(row) => row.mobile}
                  pageSize={5}
                  defaultDensity="compact"
                  //rowHeight={100}
                  rowsPerPageOptions={[5, 10, 20]}
                  //rowsPerPage={5}
                  pagination
                  components={{
                    NoRowsOverlay: () => (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <p>No Enquiries available</p>
                      </div>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
